import React from 'react';
import '../style/LoadingStyle.scss'

function Loading(props) {
  return (
    <div className="d-flex h-100 justify-content-center align-items-center">
      <div className="wave-container">
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
      </div>
    </div>
  );
}

export default Loading;